// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"3124": "58acf568a9ce7ea0","424": "e2e89380b161bdbd","8508": "268409827894db58",}[chunkId] + ".css"
}// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"3124": "58acf568a9ce7ea0","424": "e2e89380b161bdbd","8508": "268409827894db58",}[chunkId] + ".css"
}